<template>
  <div>
    <v-skeleton-loader
      v-if="loading"
      elevation="2"
      type="card-heading, list-item-two-line, divider, card-heading, list-item-two-line, divider, card-heading, list-item-two-line"
    ></v-skeleton-loader>
    <v-card v-else-if="deadlineEntries.length > 0">
      <v-data-iterator
        :items="deadlineEntries"
        no-data-text="Keine persönlichen Fristeneinträge vorhanden"
        disable-pagination
        hide-default-footer
        item-key="meta.id"
      >
        <template v-if="!hideHeader" v-slot:header>
          <v-card flat>
            <v-card-title class="body-2 v-card__subtitle"
              ><v-icon left small class="mr-2">mdi-timer-sand</v-icon>Fristen
            </v-card-title>
          </v-card>
        </template>
        <template v-slot:default="props">
          <v-row no-gutters>
            <v-col v-for="(item, index) in props.items" :key="index" cols="12">
              <deadline-entry-list-item
                :deadlineEntry="item"
              ></deadline-entry-list-item>
              <v-divider v-if="props.items.length != index + 1"></v-divider>
            </v-col>
          </v-row>
        </template>
      </v-data-iterator>
    </v-card>
    <div v-else>Keine persönlichen Fristeneinträge vorhanden</div>
  </div>
</template>

<script>
import { auth } from "@/firebase";
// import { DUTY_MANAGEMENT } from "@/store/modules.js";
// import { GET_REPORTS } from "@/store/action-types.js";
// import DutyTypeChip from "@/components/duty-management/DutyTypeChip.vue";
// import ReportStatusChip from "@/components/duty-management/ReportStatusChip.vue";
import DeadlineEntryListItem from "@/components/member-management/deadlines/DeadlineEntryListItem.vue";
export default {
  name: "personnel-records-deadlines-data-list",
  props: {
    hideHeader: {
      type: Boolean,
      default: false,
    },
    deadlineEntries: {
      type: Array,
      default: () => [],
    },
    showUpdateButton: {
      type: Boolean,
      default: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    // DutyTypeChip,
    // ReportStatusChip,
    DeadlineEntryListItem,
  },
  data() {
    return {
      currentUserUid: auth.currentUser.uid,
    };
  },
  computed: {},
  created() {
    // this.initialize();
  },
  methods: {
    // initialize() {},
  },
};
</script>
